import { render, staticRenderFns } from "./AuskunftWeek.vue?vue&type=template&id=02127efe&scoped=true&"
import script from "./AuskunftWeek.vue?vue&type=script&lang=js&"
export * from "./AuskunftWeek.vue?vue&type=script&lang=js&"
import style0 from "./AuskunftWeek.vue?vue&type=style&index=0&id=02127efe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02127efe",
  null
  
)

export default component.exports